import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=ba17e264&scoped=true&"
import script from "./TaskCreate.vue?vue&type=script&lang=js&"
export * from "./TaskCreate.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=ba17e264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba17e264",
  null
  
)

export default component.exports